import { render, staticRenderFns } from "./ChatOnlineCardComponent.vue?vue&type=template&id=6f92b9de&scoped=true"
import script from "./ChatOnlineCardComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChatOnlineCardComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ChatOnlineCardComponent.vue?vue&type=style&index=0&id=6f92b9de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f92b9de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f92b9de')) {
      api.createRecord('6f92b9de', component.options)
    } else {
      api.reload('6f92b9de', component.options)
    }
    module.hot.accept("./ChatOnlineCardComponent.vue?vue&type=template&id=6f92b9de&scoped=true", function () {
      api.rerender('6f92b9de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SupportServiceDialog/ChatOnlineCardComponent.vue"
export default component.exports